module.exports = __webpack_public_path__ + "static/media/005.a2c0622e.jpg";